import SpotDetailPage from './SpotDetailPage'
export default SpotDetailPage